import React, { useEffect, useState } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import RefundsDetailView from '../Views/RefundsDetailView';
import { ISelectedItems, Item, RefundsRequest } from '../../types/refunds-response';
import {
  useExportRefund,
  useFetchRefundById,
  useFetchRefundByIdItems,
  useManageItemsRefund,
  useVoucherRefund,
} from '../../../../hooks';
import {
  useRefundManageValidatorGestor,
  useRefundManageValidatorGestorItems,
} from '../../../../utils/validators/refund-request/refund-manage-validator';
import { useRefundStates } from '../../../../share';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import ModalAdditions from '../components/ModalAdditions';

interface RefundsDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  dataApi?: RefundsRequest;
  isLoading: boolean;
  gestorFromWarehouse?: boolean;
  refetch?: () => void;
  id?: string;
  items?: Item[];
  isLoadingItems?: boolean;
}

const RefundsDetailContainer: React.FC<RefundsDetailProps> = ({
  isOpen,
  OnClose,
  dataApi,
  isLoading,
  gestorFromWarehouse = false,
  refetch,
  id,
  items,
  isLoadingItems,
}) => {
  const { data: refundStates } = useRefundStates();

  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);
  const { mutateAsync } = useExportRefund();
  const { mutateAsync: onVoucher } = useVoucherRefund();

  const { showToast } = useCustomToast();
  const { mutateAsync: updateManageItems } = useManageItemsRefund();
  const [modalSignConfirmOpen, setModalSignConfirmOpen] = React.useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedItemsFull, setSelectedItemsFull] = useState<ISelectedItems[]>(
    []
  );

  const [additionSelected, setAdditionSelected] = useState({});
  const [isModalAdditions, setIsModalAdditions] = useState<boolean>(false);
  const [data, setData] = useState<RefundsRequest>();
  const [modalOneAsset, setModalOneAsset] = useState(false);
  const [isGestorAny, setIsGestorAny] = useState(false);
  const [isLoadingFull, setIsLoadingFull] = useState(false);
  const [dataItems, setDataItems] = useState<Item[]>(items || []);

  const [modalAllAsset, setModalAllAsset] = useState<boolean>(false);

  const { data: detailData, isPending: isLoadingData, refetch: refetchId } =
    useFetchRefundById(id);

  const { data: itemsResponse, isPending: isLoadingItemsResponse, refetch: refetchItems } =
    useFetchRefundByIdItems(id);

  const handleDataState = (values: any) => {
    setData(values);
  };
  useEffect(() => {
    if (detailData || dataApi) {
      handleDataState(detailData || dataApi);
    }
  }, [detailData, dataApi]);

  const onReset = () => {
    formikGestor.resetForm();
    formikItem.resetForm();
    OnClose();
    setSelectedRowKeys([]);
  };

  /* Actualizar solicitud */
  const manageRefundGestor = async (values: any) => {
    try {
      const payload: any = {
        observations: values.reason,
        items: selectedItemsFull,
      };
      const response: any = await updateManageItems({ data: payload });
     
      if (refetchId) refetchId();

      if (response.success) {
        setIsLoadingFull(false);
        showToast('success', 'Solicitud de reintegro ha sido actualizada.');
        const updatedItems = data?.items.map((item) => {
          const updated = response.data.items.find(
            (res: any) => res.id === item.id
          );
          return updated ? { ...item, ...updated } : item;
        });
        const updatedData = { ...data, items: updatedItems };

        handleDataState(updatedData);
      } else {
        showToast('error', 'No se pudo actualizar la solicitud.');
      }

      if (refetch) {
        refetch();
      }
      onReset();
    } catch (error) {
      showToast('error', 'Error al actualizar los estados');
    }
  };
  const onSaveRefundGestor = (values: any) => {
    manageRefundGestor(values);
  };
  const formikGestor = useRefundManageValidatorGestor({
    onSubmit: onSaveRefundGestor,
  });

  const formikItem = useRefundManageValidatorGestorItems({
    onSubmit: () => {},
  });
  const handleSubmit = async () => {
    setIsLoadingFull(true);
    if (!formikGestor.isValid) {
      showToast('error', 'Error al actualizar la solicitud.');
      setModalSignConfirmOpen(false);
      return;
    }

    /* aa */
    await formikGestor.handleSubmit();
  };

  const handleSubmitValidate = () => {
    if (!modalSignConfirmOpen) {
      setModalSignConfirmOpen(true);
    }
  };

  const handleModalAdditions = (opc: boolean) => {
    setIsModalAdditions(opc);
  };
  const handleSaveAddition = (data: any) => {
    setAdditionSelected(data);
    handleModalAdditions(true);
  };

  useEffect(() => {
    if (itemsResponse || items) {
      setDataItems(itemsResponse ?? items ?? []);
    }
  }, [itemsResponse, items]);

  return (
    <CustomModal
      title={`Detalle reintegro - ${data?.ticket || ''}`}
      labelSubmit={gestorFromWarehouse ? 'Guardar solicitud' : ''}
      labelCancel={gestorFromWarehouse ? 'Cerrar' : 'Finalizar'}
      onSave={handleSubmitValidate}
      open={isOpen}
      onCancel={OnClose}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      disabledBtn={!isGestorAny}
    >
      <RefundsDetailView
        detailData={data}
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        onVoucher={onVoucher}
        refundStates={refundStates}
        formikGestor={formikGestor}
        handleSaveAddition={handleSaveAddition}
        gestorFromWarehouse={gestorFromWarehouse}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedItemsFull={selectedItemsFull}
        setSelectedItemsFull={setSelectedItemsFull}
        modalOneAsset={modalOneAsset}
        setModalOneAsset={setModalOneAsset}
        modalAllAsset={modalAllAsset}
        setModalAllAsset={setModalAllAsset}
        setIsGestorAny={setIsGestorAny}
        formikItem={formikItem}
        dataItems={dataItems}
        isLoadingItems={(isLoadingItems ?? false) && (isLoadingItemsResponse ?? false)}
      />

      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de gestionar esta solicitud de reintegro?"
        textTwo="Una vez gestionado no podrá realizar cambios."
        open={modalSignConfirmOpen}
        width={900}
        isLoadingSave={isLoadingFull}
        onClose={() => setModalSignConfirmOpen(false)}
        labelSubmit="Aceptar"
        onSave={handleSubmit}
      />

      <ModalAdditions
        onSave={() => alert('a')}
        isShow={isModalAdditions}
        handleModalAdditions={handleModalAdditions}
        formik={formikGestor}
        additionSelected={additionSelected}
      />
    </CustomModal>
  );
};

export default RefundsDetailContainer;
